import { Paginador } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"

const listaDeEstadosInvalidos = ['erro', 'negado']

/**
 * Função para realizar requisições enquanto houver dados nas próximas páginas,
 * basta informar o leitor na chamada da função.
 * TODO Mudar essa função para um composable ou adicioná-la como extensora do leitor de dados base
 */
export const buscarDadosAteUltimaPagina = <T>(leitor: Paginador<T>): Promise<T[]> => {
  return new Promise(async (resolve, reject) => {
    let resultados: T[] = []

    try {
      resultados = await buscarDadosDaPrimeiraPagina(leitor)
      resultados = await buscarDadosDasProximasPaginas(leitor, resultados)
      resolve(resultados)
    } catch (error) {
      reject(error)
    }
  })
}

const buscarDadosDaPrimeiraPagina = async <T>(leitor: Paginador<T>): Promise<T[]> => {
  await leitor.executar()

  if (leitor.resultado.status === "sucesso") {
    return leitor.resultado.dados
  } else if (listaDeEstadosInvalidos.includes(leitor.resultado.status)) {
    throw leitor.resultado.status
  } else {
    return []
  }
}

const buscarDadosDasProximasPaginas = async <T>(leitor: Paginador<T>, resultados: T[]): Promise<T[]> => {
  while (leitor.possuiMaisItensNaProximaPagina()) {
    await leitor.proximo()

    if (leitor.resultado.status === "sucesso") {
      resultados = resultados.concat(leitor.resultado.dados)
    } else if (listaDeEstadosInvalidos.includes(leitor.resultado.status)) {
      throw leitor.resultado
    } else {
      break
    }
  }

  return resultados
}
